var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampRoutes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 76.5C56.3823 76.5 72.5 60.3823 72.5 40.5C72.5 20.6178 56.3823 4.5 36.5 4.5C16.6178 4.5 0.5 20.6178 0.5 40.5C0.5 60.3823 16.6178 76.5 36.5 76.5Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 71.5C59.83 71.5 75.5 55.83 75.5 36.5C75.5 17.17 59.83 1.5 40.5 1.5C21.17 1.5 5.5 17.17 5.5 36.5C5.5 55.83 21.17 71.5 40.5 71.5Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 71.5C59.83 71.5 75.5 55.83 75.5 36.5C75.5 17.17 59.83 1.5 40.5 1.5C21.17 1.5 5.5 17.17 5.5 36.5C5.5 55.83 21.17 71.5 40.5 71.5Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 14.5C39.3954 14.5 38.5 15.3954 38.5 16.5V70.5C38.5 71.6046 39.3954 72.5 40.5 72.5C41.6046 72.5 42.5 71.6046 42.5 70.5V16.5C42.5 15.3954 41.6046 14.5 40.5 14.5Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18.5C21.2032 18.5 20.9218 18.6318 20.7318 18.8598L15.7318 24.8598C15.4227 25.2307 15.4227 25.7693 15.7318 26.1402L20.7318 32.1402C20.9218 32.3682 21.2032 32.5 21.5 32.5H37.5C38.0523 32.5 38.5 32.0523 38.5 31.5V19.5C38.5 18.9477 38.0523 18.5 37.5 18.5H21.5Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7381 38.5C60.0283 38.5 60.3042 38.3739 60.4941 38.1546L65.256 32.6546C65.5813 32.2788 65.5813 31.7212 65.256 31.3454L60.4941 25.8454C60.3042 25.6261 60.0283 25.5 59.7381 25.5L43.5 25.5C42.9477 25.5 42.5 25.9477 42.5 26.5L42.5 37.5C42.5 37.7652 42.6054 38.0196 42.7929 38.2071C42.9804 38.3946 43.2348 38.5 43.5 38.5L59.7381 38.5Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 25.9206C34.1036 25.9693 33.5094 25.9329 32.9766 25.5882C32.8606 25.5132 32.6902 25.5506 32.6207 25.67C32.435 25.9889 32.113 26.4577 31.8889 26.7544C31.7959 26.8776 31.6315 26.8311 31.6034 26.6793L31.3527 25.322C31.3223 25.1578 31.1148 25.1013 31.0024 25.2248C28.4782 27.9972 28.1378 26.8414 25.9943 25.4186C25.5682 25.1358 26.3182 24.7395 26.6591 23.9965C27.5254 22.1084 29.6944 26.1308 26.9722 27.302C25.5139 27.9295 24.1634 26.978 24.0363 25.6768C24.0181 25.4907 23.769 25.3525 23.6126 25.455C23.2973 25.6616 22.8885 25.8799 22.5 25.9635",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 32.3678C59.0751 32.4397 58.4404 32.3873 57.868 31.8886C57.747 31.7833 57.5354 31.8244 57.4734 31.9722C57.2578 32.4863 56.8593 33.2785 56.6138 33.7142C56.538 33.8487 56.3656 33.8265 56.3139 33.6811L54.9862 29.9465C54.9269 29.7798 54.6929 29.7711 54.612 29.9284C51.8178 35.3547 51.8037 30.2154 51.2273 33.5604C50.8699 35.6341 48.4435 33.9198 48.188 31.8521C48.1636 31.6551 47.8651 31.5291 47.718 31.6625C47.3747 31.9737 46.9261 32.3058 46.5 32.4319",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5952 39.5C26.3087 39.5 26.036 39.6229 25.8461 39.8375L22.7509 43.3375C22.4164 43.7158 22.4164 44.2842 22.7509 44.6625L25.8461 48.1625C26.036 48.3771 26.3087 48.5 26.5952 48.5H37.5C38.0523 48.5 38.5 48.0523 38.5 47.5V40.5C38.5 39.9477 38.0523 39.5 37.5 39.5H26.5952Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 45C36.3393 45.0141 36.1005 43.6122 35.8833 43.0995C35.8384 42.9938 35.7109 42.9989 35.6327 43.0829C35.3505 43.3858 34.717 44.0236 34.445 44.2861C34.374 44.3546 34.2723 44.3463 34.2083 44.2711L32.9461 42.7862C32.8424 42.6642 32.6428 42.7099 32.5861 42.8597C31.8926 44.6905 30.9631 42.1253 30.3182 44.3121C30.2069 44.6893 29.4304 44.4463 29.2032 44.0918C29.1311 43.9793 29.0138 43.845 28.8806 43.8557C27.9921 43.9273 27.737 44.0499 27.5 44.0864",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 71.5C59.83 71.5 75.5 55.83 75.5 36.5C75.5 17.17 59.83 1.5 40.5 1.5C21.17 1.5 5.5 17.17 5.5 36.5C5.5 55.83 21.17 71.5 40.5 71.5Z",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampRoutes);
export default __webpack_public_path__ + "static/media/ic-stamp-routes.182308790e9ec120b943ff610b2653a9.svg";
export { ForwardRef as ReactComponent };